import {createContext} from "react";
import {AppUser} from "../utils/auth";
import {AuthenticatedUser} from "warded-lock/dist";

export const UserContext = createContext<AppUser>(null);
